<template>
   <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>
<script>
import AppLayout from "./views/shared/AppLayout";
import EmptyLayout from "./views/shared/EmptyLayout";
import AdminLayout from "./views/shared/AdminLayout";
import { authenticationService } from "@/_services";

export default {
  name: "App",
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: {
    "app-layout": AppLayout,
    "empty-layout": EmptyLayout,
    "admin-layout": AdminLayout
  },
  created() {
    // Sayfa yenilendiğinde olması gereken layout ne ise onu ayarlayamayı sağlımak için !
    const currentUser = authenticationService.currentUserValue;
    const currentPath = this.$route.path;
    
    if (currentUser) {
      if (currentUser.isAdmin && currentPath.startsWith('/admin')) {
        this.$store.commit("SET_LAYOUT", "admin-layout");
      } else if (!currentPath.startsWith('/admin')) {
        this.$store.commit("SET_LAYOUT", "app-layout");
      }
    }
  }
};
</script>
